import axios from "../axiosInstance";
import {
  AdminEnrollMemberParams,
  AdminEnrollMemberResponse,
} from "./types";

export const adminEnrollMember = async (
  params: AdminEnrollMemberParams,
): Promise<AdminEnrollMemberResponse> => {
  const response = await axios.post<AdminEnrollMemberResponse>(
    `/api/learning-center/admin/enrollments`,
    {
      courseId: params.courseId,
      userId: params.userId,
    },
  );
  return response.data;
};
